import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { cn } from '@/lib/utils';

type ButtonStyle = 'amber' | 'green' | 'red';

const buttonStyles: Record<ButtonStyle, string> = {
  amber: 'bg-warning text-[#081631] hover:opacity-90',
  green: 'bg-success text-white hover:opacity-90',
  red: 'bg-error text-white hover:opacity-90',
};

interface ConfirmActionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  actionLabel: string;
  buttonStyle?: ButtonStyle;
  onConfirm: () => void;
  loading?: boolean;
  loadingLabel?: string;
}

export function ConfirmActionDialog({
  open,
  onOpenChange,
  title,
  description,
  actionLabel,
  buttonStyle = 'amber',
  onConfirm,
  loading = false,
  loadingLabel,
}: ConfirmActionDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className={cn(buttonStyles[buttonStyle])}
            disabled={loading}
            onClick={onConfirm}
          >
            {loading ? (loadingLabel ?? 'Processing...') : actionLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
